import { useTranslation } from 'react-i18next'

import ComponentStyled from './styled'

type Props = {
  active?: boolean
  userImage?: string
  title?: string
  target?: number
}

const Milestone = ({ active = false, userImage = '', target = 0, title }: Props): JSX.Element => {
  const { t } = useTranslation()

  return (
    <ComponentStyled active={active} userImage={userImage}>
      <div className='main-box'>
        <div className='wish-info'>
          <p className='total'>{target}</p>
          <p className='wishes'>{t('wishes')}</p>
        </div>
        <div className='seed-info'>
          <p className='seed-type'>{title}</p>
          <p className='time'>{t('100 years')}</p>
        </div>
      </div>
    </ComponentStyled>
  )
}

export default Milestone
